import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule}  from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { LoginComponent } from './login/login.component';
import {TranslateModule} from "@ngx-translate/core";
import {LogoutComponent} from "./logout/logout.component";
 
@NgModule({ declarations: [
        LoginComponent,
        LogoutComponent,
    ], imports: [CommonModule,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        ReactiveFormsModule,
        TranslateModule], providers: [provideHttpClient(withXhr(), withInterceptorsFromDi())] })
export class TmAuthModule{
}